import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import PlotCategory from "../pages/category/plot/page";
import CastCategory from "../pages/category/cast/page";
import CastDetail from "../pages/detail/cast/page";
import PlayPage from "../pages/play/page";
import RecommendSpecial from "../pages/special/recommend/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/plot",
        element: <PlotCategory />,
      },
      {
        path: "/category/cast",
        element: <CastCategory />,
      },
      {
        path: "/detail/cast/:id",
        element: <CastDetail />,
      },
      {
        path: "/play/:episode",
        element: <PlayPage />,
      },
      {
        path: "/special/recommend",
        element: <RecommendSpecial />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;